(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-blocks"] && !Shopify.designMode) return;
  try {
    
(function(){
  const root = document.currentScript.closest('.cbx-collection');
  if(!root) return;
  const hero = root.querySelector('.cbx-hero');
  const sidebar = root.querySelector('.cbx-sidebar');
  const scroller = root.querySelector('.cbx-mobile-scroller');

  // Push sidebar down to start under the hero (desktop only)
  function offsetSidebar(){
    if (!hero || !sidebar) return;
    const mq = window.matchMedia('(max-width: 1024px)');
    if (mq.matches){
      sidebar.style.setProperty('--hero-offset', '0px');
      return;
    }
    const h = hero.offsetHeight || 0;
    sidebar.style.setProperty('--hero-offset', h + 'px');
  }

  window.addEventListener('resize', offsetSidebar);
  window.addEventListener('load', offsetSidebar);
  const img = hero ? hero.querySelector('img') : null;
  if (img) img.addEventListener('load', offsetSidebar);
  offsetSidebar();

  // Allow vertical wheel to scroll the mobile pill bar horizontally
  if (scroller){
    scroller.addEventListener('wheel', (e)=>{
      if(Math.abs(e.deltaX) < Math.abs(e.deltaY)){
        scroller.scrollLeft += e.deltaY;
        e.preventDefault();
      }
    }, {passive:false});
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-product-slider"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $(".product_slider").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false, // Disable default slick arrows, we will use custom buttons
        infinite: true,
        autoplay: false,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                slidesToShow: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                slidesToShow: 2
                }
            }
        ]
    });

    // Click handlers for custom buttons
    $(".prev-btn").click(function () {
        $(".product_slider").slick("slickPrev");
    });

    $(".next-btn").click(function () {
        $(".product_slider").slick("slickNext");
    });

    // Disable prev button initially (if starting on the first slide)
    $(".prev-btn").addClass("slick-disabled");

    // Handle enabling/disabling custom buttons based on slider state
    $(".product_slider").on("afterChange", function (event, slick, currentSlide) {
        // Check if the first slide is active, disable prev button
        if (currentSlide === 0) {
            $(".prev-btn").addClass("slick-disabled");
        } else {
            $(".prev-btn").removeClass("slick-disabled");
        }

        // Check if the last slide is active, disable next button
        if (currentSlide === slick.slideCount - slick.options.slidesToShow) {
            $(".next-btn").addClass("slick-disabled");
        } else {
            $(".next-btn").removeClass("slick-disabled");
        }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-reveiw-slider"] && !Shopify.designMode) return;
  try {
    
  $('.customerslider').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 2000,
  dots: true,
  infinite: true,
  responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-with-sidebar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.currentScript && document.currentScript.closest('.cbx-faq');
    if (!root) return;

    // Read sticky offset from data-attribute; fallback to CSS var; finally to 72
    let offset = parseInt(root.dataset.stickyOffset, 10);
    if (isNaN(offset) || offset <= 0) {
      const scroller = root.querySelector('.cbx-mobile-scroller');
      if (scroller) {
        const v = getComputedStyle(scroller).getPropertyValue('--faq-sticky-offset').trim();
        const n = parseInt(v, 10);
        if (!isNaN(n)) offset = n;
      }
    }
    if (isNaN(offset) || offset <= 0) offset = 72;

    function openAndScrollTo(hash) {
      if (!hash || hash === '#') return;
      const id = hash.charAt(0) === '#' ? hash.slice(1) : hash;
      const section = document.getElementById(id);
      if (!section) return;
      const y = section.getBoundingClientRect().top + window.scrollY - offset - 8;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }

    // In-page anchor clicks only (for in-section bar)
    root.addEventListener(
      'click',
      (e) => {
        const a = e.target.closest('a[href^="#"]');
        if (!a) return;
        const href = a.getAttribute('href') || '';
        if (!href || href === '#') return;
        e.preventDefault();
        openAndScrollTo(href);
        if (history && history.replaceState) history.replaceState(null, '', href);
      },
      { passive: true }
    );

    if (location.hash) {
      setTimeout(() => openAndScrollTo(location.hash), 50);
    }
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-article"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};

      this.onViewportChangeHandler =
        this.updateStickyTopOffset.bind(this);

      this.updateStickyTopOffset();
      this.setHeaderHeight();

      window
        .matchMedia('(max-width: 990px)')
        .addEventListener(
          'change',
          this.setHeaderHeight.bind(this)
        );

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add(
          'shopify-section-header-sticky'
        );
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.predictiveSearch =
        this.querySelector('predictive-search');

      this.onScrollHandler =
        this.onScroll.bind(this);

      this.hideHeaderOnScrollUp =
        () => this.preventReveal = true;

      this.addEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.addEventListener(
        'scroll',
        this.onScrollHandler,
        false
      );

      window.addEventListener(
        'resize',
        this.onViewportChangeHandler
      );

      window.addEventListener(
        'load',
        this.onViewportChangeHandler
      );

      this.createObserver();
    }

    updateStickyTopOffset() {
      if (!this.header) {
        return;
      }

      let stackBottom = 0;
      const tolerance = 2;

      document
        .querySelectorAll('.shopify-section')
        .forEach(section => {
          if (section === this.header) {
            return;
          }

          const relation =
            section.compareDocumentPosition(
              this.header
            );

          if (
            !(
              relation &
              Node.DOCUMENT_POSITION_FOLLOWING
            )
          ) {
            return;
          }

          const style =
            window.getComputedStyle(section);

          if (
            style.display === 'none' ||
            style.visibility === 'hidden'
          ) {
            return;
          }

          if (
            style.position !== 'sticky' &&
            style.position !== 'fixed'
          ) {
            return;
          }

          const rect =
            section.getBoundingClientRect();

          if (
            rect.height <= 0 ||
            rect.bottom <= 0
          ) {
            return;
          }

          if (
            rect.top <= stackBottom + tolerance &&
            rect.bottom > stackBottom
          ) {
            stackBottom = rect.bottom;
          }
        });

      document.documentElement.style.setProperty(
        '--site-sticky-top-offset',
        `${Math.max(0, Math.round(stackBottom))}px`
      );
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );
    }

    disconnectedCallback() {
      this.removeEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.removeEventListener(
        'scroll',
        this.onScrollHandler
      );

      window.removeEventListener(
        'resize',
        this.onViewportChangeHandler
      );

      window.removeEventListener(
        'load',
        this.onViewportChangeHandler
      );
    }

    createObserver() {
      let observer = new IntersectionObserver(
        (entries, observer) => {
          this.headerBounds =
            entries[0].intersectionRect;

          observer.disconnect();
        }
      );

      observer.observe(this.header);
    }

    onScroll() {
      this.updateStickyTopOffset();

      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop;

      if (
        this.predictiveSearch &&
        this.predictiveSearch.isOpen
      ) {
        return;
      }

      if (
        scrollTop > this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.header.classList.add(
          'scrolled-past-header'
        );

        if (this.preventHide) {
          return;
        }

        requestAnimationFrame(
          this.hide.bind(this)
        );

      } else if (
        scrollTop < this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.header.classList.add(
          'scrolled-past-header'
        );

        if (!this.preventReveal) {
          requestAnimationFrame(
            this.reveal.bind(this)
          );
        } else {
          window.clearTimeout(
            this.isScrolling
          );

          this.isScrolling =
            setTimeout(() => {
              this.preventReveal = false;
            }, 66);

          requestAnimationFrame(
            this.hide.bind(this)
          );
        }

      } else if (
        scrollTop <= this.headerBounds.top
      ) {
        this.header.classList.remove(
          'scrolled-past-header'
        );

        requestAnimationFrame(
          this.reset.bind(this)
        );
      }

      this.currentScrollTop =
        scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) {
        return;
      }

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) {
        return;
      }

      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );

      this.header.classList.remove(
        'shopify-section-header-hidden'
      );
    }

    reset() {
      if (this.headerIsAlwaysSticky) {
        return;
      }

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {
      this.disclosures =
        this.disclosures ||
        this.header.querySelectorAll(
          'header-menu'
        );

      this.disclosures.forEach(
        disclosure => disclosure.close()
      );
    }

    closeSearchModal() {
      this.searchModal =
        this.searchModal ||
        this.header.querySelector(
          'details-modal'
        );

      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define(
      'sticky-header',
      StickyHeader
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-customer-review"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $(".rev_slider").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false, // Disable default slick arrows, we will use custom buttons
        infinite: false,
        autoplay: false,
        dots: false,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                slidesToShow: 1,
                dots: true,
                }
            },
            {
                breakpoint: 480,
                settings: {
                slidesToShow: 1,
                dots: true,
                }
            }
        ]
    });

    // Click handlers for custom buttons
    $(".prev-btn").click(function () {
        $(".rev_slider").slick("slickPrev");
    });

    $(".next-btn").click(function () {
        $(".rev_slider").slick("slickNext");
    });

    // Disable prev button initially (if starting on the first slide)
    $(".prev-btn").addClass("slick-disabled");

    // Handle enabling/disabling custom buttons based on slider state
    $(".product_slider").on("afterChange", function (event, slick, currentSlide) {
        // Check if the first slide is active, disable prev button
        if (currentSlide === 0) {
            $(".prev-btn").addClass("slick-disabled");
        } else {
            $(".prev-btn").removeClass("slick-disabled");
        }

        // Check if the last slide is active, disable next button
        if (currentSlide === slick.slideCount - slick.options.slidesToShow) {
            $(".next-btn").addClass("slick-disabled");
        } else {
            $(".next-btn").removeClass("slick-disabled");
        }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-product-slider"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $(".product_slider").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false, // Disable default slick arrows, we will use custom buttons
        infinite: true,
        autoplay: false,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                slidesToShow: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                slidesToShow: 2
                }
            }
        ]
    });

    // Click handlers for custom buttons
    $(".prev-btn").click(function () {
        $(".product_slider").slick("slickPrev");
    });

    $(".next-btn").click(function () {
        $(".product_slider").slick("slickNext");
    });

    // Disable prev button initially (if starting on the first slide)
    $(".prev-btn").addClass("slick-disabled");

    // Handle enabling/disabling custom buttons based on slider state
    $(".product_slider").on("afterChange", function (event, slick, currentSlide) {
        // Check if the first slide is active, disable prev button
        if (currentSlide === 0) {
            $(".prev-btn").addClass("slick-disabled");
        } else {
            $(".prev-btn").removeClass("slick-disabled");
        }

        // Check if the last slide is active, disable next button
        if (currentSlide === slick.slideCount - slick.options.slidesToShow) {
            $(".next-btn").addClass("slick-disabled");
        } else {
            $(".next-btn").removeClass("slick-disabled");
        }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["taima-collection-navigation"] && !Shopify.designMode) return;
  try {
    
(function(){
  // NOTE: Shopify concatenates every section's javascript tag into one
  // bundled file, so `document.currentScript` does NOT point at this section
  // (it's null / the bundle script) — that's why the earlier sort never bound.
  // Instead, initialise every instance of this section found in the DOM.
  function initRoot(root){
    var scroller = root.querySelector('.rkt-category-scroller');
    var grid = root.querySelector('.rkt-grid');
    // Only the MANUAL-mode select carries data-rkt-sort; the auto-mode select
    // uses Shopify's native server-side sort_by (inline onchange) instead.
    var sortSelect = root.querySelector('[data-rkt-sort]');

    // Allow vertical wheel to scroll the category icon row horizontally
    if (scroller){
      scroller.addEventListener('wheel', function(e){
        if (Math.abs(e.deltaX) < Math.abs(e.deltaY)){
          scroller.scrollLeft += e.deltaY;
          e.preventDefault();
        }
      }, {passive:false});
    }

    // Size the select to the width of its currently-selected option so the
    // caret sits right next to the value instead of at the widest option's edge.
    function fitSelect(sel){
      if (!sel || !sel.options.length) return;
      var opt = sel.options[sel.selectedIndex];
      var cs = window.getComputedStyle(sel);
      var meas = document.createElement('span');
      meas.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;'
        + 'font-family:' + cs.fontFamily + ';font-size:' + cs.fontSize
        + ';font-weight:' + cs.fontWeight + ';letter-spacing:' + cs.letterSpacing;
      meas.textContent = opt ? opt.text : '';
      document.body.appendChild(meas);
      sel.style.width = Math.ceil(meas.getBoundingClientRect().width + 2) + 'px';
      document.body.removeChild(meas);
    }

    // --- Client-side price sort (works for BOTH manual cards and real
    // products — every .rkt-card carries data-price). ---
    if (grid && sortSelect){
      var originalOrder = Array.prototype.slice.call(grid.querySelectorAll('.rkt-card'));
      var promoTile = grid.querySelector('.rkt-promo-tile');

      function placePromoTile(cards){
        if (!promoTile) return;
        var position = parseInt(promoTile.getAttribute('data-promo-position'), 10);
        if (!position || position < 1) position = 5;

        var cardAtPosition = cards[position - 1];
        if (cardAtPosition){
          grid.insertBefore(promoTile, cardAtPosition);
        } else {
          grid.appendChild(promoTile);
        }
      }

      function priceOf(card){
        var v = parseFloat(card.getAttribute('data-price'));
        return isNaN(v) ? 0 : v;
      }

      function applySort(mode){
        var ordered;
        if (mode === 'price-asc'){
          ordered = originalOrder.slice().sort(function(a, b){ return priceOf(a) - priceOf(b); });
        } else if (mode === 'price-desc'){
          ordered = originalOrder.slice().sort(function(a, b){ return priceOf(b) - priceOf(a); });
        } else {
          ordered = originalOrder;
        }
        ordered.forEach(function(card){ grid.appendChild(card); });
        placePromoTile(ordered);
      }

      placePromoTile(originalOrder);

      sortSelect.addEventListener('change', function(e){
        applySort(e.target.value);
        fitSelect(sortSelect);
      });
    }

    if (sortSelect) fitSelect(sortSelect);
  }

  function initAll(){
    document.querySelectorAll('.rkt-collection').forEach(initRoot);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
